<template>
  <div class="mod-config" style="height: 100%">
    <div class="list_ul">
      <ul>
        <li @click="getDevices('1')">
          <p style="line-height: 40px;">待处理</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workStatusPro.pending }}</p>
        </li>
        <li @click="getDevices('2')">
          <p style="line-height: 40px;">处理中</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workStatusPro.processing }}</p>
        </li>
        <li @click="getDevices('3')">
          <p style="line-height: 40px;">已结束</p>
          <p style="line-height: 20px;font-size: 20px;">{{ workStatusPro.end }}</p>
        </li>
      </ul>
    </div>
    <div style="position: absolute;top: 152px;right: 10px;margin-bottom: 0px;">
      <el-button @click="search(-1)" type="primary" icon="el-icon-search"></el-button>
      <el-button @click="addOrUpdateHandle()" type="primary" v-if="isAuth('workSheet:add')">新增</el-button>
      <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0"
        v-if="isAuth('recharge:delete')">批量删除</el-button>
    </div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="height: 80px;">
      <el-form-item>
        <label>工单标题：</label>
        <el-input v-model="dataForm.title" placeholder="工单标题" clearable style="width: calc(100% - 100px);"></el-input>
      </el-form-item>
      <el-form-item>
        <label>选择时间：</label>
        <el-date-picker v-model="dataForm.dateStr" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="information">
      <i class="el-icon-phone" style="font-size: 30px;"></i>
    </div>
    <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 260px)" border stripe :header-cell-style="{background:'#FAFAFA'}"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="工单编号" width="80">
      </el-table-column>
      <el-table-column prop="title" header-align="center" align="center" label="工单标题">
      </el-table-column>
      <el-table-column prop="deviceName" header-align="center" align="center" label="设备名称">
      </el-table-column>
      <el-table-column prop="commitUserName" header-align="center" align="center" label="提交账号">
      </el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="提交时间" sortable>
      </el-table-column>
      <el-table-column prop="statusName" header-align="center" align="center" label="工单状态">
      </el-table-column>
      <el-table-column header-align="center" align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="addOrUpdateHandle(scope.row.id)"><span
              class="edit-btn">详情</span>
          </el-button>
          <el-button v-if="scope.row.companyId == user.id" size="mini" type="success" :disabled="scope.row.status !== 4"
            @click="handleModify(scope.row.id)"><span class="edit-btn">评价</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    <!--  评价  -->
    <el-dialog title="评价" :visible.sync="evaluate" :modal-append-to-body="false" :close-on-click-modal="false"
      width="30%" height="100%" style="top: 10%;text-align: center;">
      <el-form style="width: 100%;display: block;">
        <el-form-item label="工单编号">
          <el-input auto-complete="off" v-model="workEvaluate.id" :disabled="true"
            style="float: left;width: 80%;"></el-input>
        </el-form-item>
        <el-form-item>
          <label class="el-form-item__label" style="width: 68px;">备注</label>
          <el-input v-model="workEvaluate.remark" placeholder="请输入备注" style="float: left;width: 80%;">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="evaluate = false">取 消</el-button>
        <el-button @click="evaluateWork()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from './workSheet-add-or-update'
import { isAuth } from "@/utils";
export default {
  data() {
    return {
      value1: '',
      dataForm: {
        title: '',
        showType: '',
        dateFromStr: '',
        dateToStr: '',
      },
      user: "",
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      workEvaluate: {
        id: '',
        remark: '',
      },
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      workStatusPro: {
        end: '',
        pending: '',
        processing: '',
      },
      evaluate: false, //修改评价框
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
    this.statusPro()
  },
  provide() {
    return {
      getDataList: this.getDataList
    }
  },
  methods: {
    //工单状态
    statusPro() {
      this.$http({
        url: this.$http.adornUrl('/workSheet/statusPro'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.workStatusPro = data.data
        }
      })
    },
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      }
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/workSheet/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'title': this.dataForm.title,
          showType: this.dataForm.showType,
          dateFromStr: this.dataForm.dateFromStr,
          dateToStr: this.dataForm.dateToStr,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          let user = JSON.parse(sessionStorage.getItem("user") || "[]")
          this.user = user;
          this.dataList = data.data.rows
          this.totalPage = data.data.total
          //重置参数
          this.dataForm.dateFromStr = '';
          this.dataForm.dateToStr = '';
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    //设备总数
    getDevices(event) {
      if (event !== -1) {
        this.dataForm.showType = event
      } else {
        this.dataForm.showType = ''
      }
      this.getDataList();
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 评价
    handleModify(id) {
      this.workEvaluate.id = id
      this.evaluate = true
    },
    //评价工单
    evaluateWork() {
      this.$http({
        url: this.$http.adornUrl(`/workSheet/comment`),
        method: 'post',
        data: this.$http.adornData({
          'id': this.workEvaluate.id,
          'remark': this.workEvaluate.remark,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.evaluate = false
          this.getDataList()
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //批量删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定要删除所选工单信息`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/workSheet/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.statusPro();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>

<style scoped>
@import '../../assets/css/indexhome.css';

.information {
  position: absolute;
  z-index: 997;
  right: 0;
  top: 59%;
  background: #fff;
  border: 1px solid #ccc;
  padding: 12px 4px;
  cursor: pointer;
}

.list_ul {
  height: 100px;
  border: 1px solid #ebeef5;
  padding: 10px;
  -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.list_ul ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
}

.list_ul ul li {
  width: 130px;
  float: left;
  color: #fff;
  margin: 0 10px;
  cursor: pointer;
  height: 70px;
  border-radius: 6px;
  padding: 0px 20px;
}

.list_ul ul li:nth-child(1) {
  background: rgb(255, 121, 112);
}

.list_ul ul li:nth-child(2) {
  background: #E6A23C;
}

.list_ul ul li:nth-child(3) {
  background: #85ce61;
}

.el-form--inline .el-form-item {
  margin: 0 !important;
}

.mod-config form {
  justify-content: initial;
}
</style>


// WEBPACK FOOTER //
// src/pages/handlecenter/workSheet.vue